import { useState, useEffect } from 'react';
import { createTheme, Button, Typography } from '@mui/material';
import { Circle } from '@mui/icons-material';
import { ThemeProvider } from '@mui/styles';
import MaterialTable from 'material-table';
import Plot from 'react-plotly.js';
import { updateUserCredit, createAuditLogCall, apiSearchCompanyExternalCall, apiGetCompanyDetailExternalCall, apiGetCompanyScoringResults} from 'lib/axiosUtils';
import { fetchMetadata } from 'lib/utils';
import Spinner from 'components/Spinner';
// import videosrc from "../../assets/videos/video1.m4v"
import ROICalculatorPage from './ROICalculatorPage';
import CompanyInfoPage from './CompanyInfoPage';
import PricingReliabilityGraph from './PricingReliabilityMatrix';
import { getRequiredCredit, updateUserSessionData } from 'lib/utils';
import { TYPE_SUCCESS, INTERVAL} from 'assets/constants/Constants';
import ShowToast from 'components/ShowToast';


const SearchProductPage = () => {
	// const [singleCollectApiResponse, setSingleCollectApiResponse] = useState({});
	const infoTabs = ['Top GenAI Usecases', 'Analyst Insights & Trends', 'Success Stories', 'Executive Perspective', 'ROI Calculator'];
	const [selectedClassificationField, setSelectedClassificationField] = useState("");
	const [selectedInfoTab, setSelectedInfoTab] = useState(infoTabs[0]);
	const [isLoading, setIsLoading] = useState(true);
	const [metaData, setMetaData] = useState({});
	const userDetail = JSON.parse(localStorage.getItem("userData"));
	const [credit, setCredit] = useState();
	const [selectedL1Item, setSelectedL1Item] = useState("");
	const [selectedL2Item, setSelectedL2Item] = useState("");
	const [searchComapnyApiResponse, setSearchComapnyApiResponse] = useState({});
	const [getComapnyDetailApiResponse, setGetComapnyDetailApiResponse] = useState(null);
	const [companyScoringResult, setCompanyScoringResult] = useState(null);
	const [domainCompaniesWithScoring, setDomainCompaniesWithScoring] = useState([]);


	const chartData = [{
		type: 'scatterpolar',
		r: [39, 28, 8, 7, 28, 39],
		theta: ['Product Feature & Functionality', 'Integration Coverage', 'Security Feature', 'Vendor Background', 'Regional Grounding'],
		fill: 'toself'
	}];

	const chartLayout = {
		width: 600,
		height: 400,
		polar: {
			radialaxis: {
				visible: true,
				range: [0, 50]
			}
		},
		showlegend: false
	};

	const industryTileClickHandler = (classificationField) => {
		setSelectedClassificationField(classificationField);
		setSelectedInfoTab(infoTabs[0]);

	};

	const infoTabClickHandler = (infoTab) => {
		setSelectedInfoTab(infoTab);
	};

	const l1TileClickHandler =(l1Item) => {
		setSelectedL1Item (l1Item)
	}

	const l2TileClickHandler =(l2Item) => {
		setSelectedL2Item (l2Item)
	}

	// useEffect(() => {
	// 	singleCollectApiResponseCall();
	// }, []);

	useEffect(() => {
		setMetadataCall();
	}, [])

	const setMetadataCall = async () => {
		let tempMetaData = JSON.parse(localStorage.getItem("metadata")) ? JSON.parse(localStorage.getItem("metadata")) : [];
		if (tempMetaData && tempMetaData.length === 0) {
			tempMetaData = await fetchMetadata();
			localStorage.setItem("metadata", JSON.stringify(tempMetaData.data.result));
			setMetaData(tempMetaData.data.result);
			setSelectedClassificationField(Object.keys(tempMetaData.data.result[0].meta_data.process_data.classification_fields)[0])
		}
		else {
			setMetaData(tempMetaData);
			setSelectedClassificationField(Object.keys(tempMetaData[0].meta_data.process_data.classification_fields)[0])
		}
	}

	// const singleCollectApiResponseCall = async () => {
	// 	try {
	// 		let requestData = {
	// 			name: "Sweep AI",
	// 			website: "https://www.sweep.dev",
	// 			linkedin: "https://www.linkedin.com/company/sweep-ai/"
	// 		}
	// 		const apiCollectResult = await apiCollectExternalCall({}, requestData)
	// 		setSingleCollectApiResponse(apiCollectResult.data);
	// 		setIsLoading(false);
	// 	}
	// 	catch (error) {
	// 		console.log("Error occured while fetching single collect API response", error);
	// 	}
	// }

	useEffect(() =>{
		const searchCompniesApiResponseCall = async () => {
			try {
				const apiSearchCompanyResult = await apiSearchCompanyExternalCall({}, {}, selectedClassificationField, selectedL1Item,selectedL2Item);
				setSearchComapnyApiResponse(apiSearchCompanyResult.data);
				setIsLoading(false);
				
				const domainCompanies = Array.isArray(apiSearchCompanyResult.data?.data)
          ? apiSearchCompanyResult.data.data
          : [];

        const domainCompaniesWithScoring = await Promise.all(
          domainCompanies.map(async (company) => {
            try {
              const scoringRes = await apiGetCompanyScoringResults(
                {},
                {},
                company.id,
              );

              return {
                ...company,
                scoringResult: scoringRes?.data || null,
              };
            } catch (err) {
              console.log("Scoring fetch failed for company:", company.id, err);
              return {
                ...company,
                scoringResult: null,
              };
            }
          }),
        );

		setDomainCompaniesWithScoring(domainCompaniesWithScoring);

	// 	const top3CompaniesByScore = [...domainCompaniesWithScoring]
    //   .filter(
    //     (company) => typeof company?.scoringResult?.total_score === "number",
    //   )
    //   .sort((a, b) => b.scoringResult.total_score - a.scoringResult.total_score)
    //   .slice(0, 3);

			}
			catch (error) {
	
				console.log("Error occured while fetching search company API response", error);
			}
		}
		searchCompniesApiResponseCall();
	},[selectedClassificationField, selectedL1Item, selectedL2Item])


	const getCompanyDetails = async(companyId) => 
	{
		try{
			const apiGetCompanyDetails = await apiGetCompanyDetailExternalCall({}, {}, companyId);
			setGetComapnyDetailApiResponse(apiGetCompanyDetails.data);

			const apiGetCompanyScoring = await apiGetCompanyScoringResults({}, {}, companyId);
			setCompanyScoringResult(apiGetCompanyScoring.data);
		}catch (error){
			console.log("Error occured while fetching get company API response", error);
			setIsLoading(false);

		}
	}

	useEffect(() => {
		const fetchCredit = async () => {
		const moduleName = "Download Report";

		const requiredCredit = await getRequiredCredit(userDetail.region_id, moduleName);
		  setCredit(requiredCredit);
		};
	
		fetchCredit();
	},[userDetail.region_id]);

	const downloadReport = async () => {
        try {
            if (userDetail.total_credit > credit) {
                if (window.confirm(`This action will deduct ${credit} credits. Are you sure you want to continue?`)) {
                   const moduleName = "Download Report";
                    const userParams = {
                        updateCredit: credit,       
                    };
					const auditParams = {
                        moduleName: moduleName,
                        userID: userDetail._id,
                        creditUsed: credit,
                        logText: `Credits Used for ${moduleName}`,
                        fileType: "pdf"
                    };
					const updateDataPromise = await Promise.all([
						updateUserCredit({}, userParams, userDetail._id),
						createAuditLogCall({}, auditParams)
					])
                    if (updateDataPromise && updateDataPromise[0] && updateDataPromise[0].statusCode === 200) {
                        await updateUserSessionData(userDetail);
                        window.location.reload();
                    }
                }
            } else {
                ShowToast("You can't do this opertaion, as You do not have required credits.", TYPE_SUCCESS, INTERVAL, "", "");
            }
        }
        catch (error) {
            console.log("Error occurre", error);
        }
    };

	return (<>
		{
			isLoading === true ? (
				<Spinner />
			) : (
				<div id='search-product-page'>
					<div className='main-content'>
						<Typography className='welcome-heading'>Welcome to your MillionAI Search - What will you discover today?</Typography>
						<div className='industry-tiles-container'> Domain: &nbsp;&nbsp;&nbsp;
							{
								metaData && metaData.length > 0 && (
									Object.keys(metaData[0].meta_data.process_data?.classification_fields).map((classificationField) => (
										<Button
											key={classificationField}
											variant={`${selectedClassificationField === classificationField ? 'contained' : 'outlined'}`}
											startIcon={<Circle className='start-icon' />}
											className={`industry-tile ${classificationField === selectedClassificationField ? 'selected-industry-tile' : ''}`}
											onClick={() => industryTileClickHandler(classificationField)}
										>
											{classificationField}
										</Button>
									))
								)
							}

						</div>

						<div className='industry-tiles-container'>L1 Process: &nbsp;&nbsp;&nbsp;
							{
								metaData?.length > 0 &&
								metaData[0]?.meta_data?.process_data?.classification_fields?.[selectedClassificationField]?.L1_Process?.map(
									(l1Item) => (
									<Button
										key={l1Item}
										variant={selectedL1Item === l1Item ? 'contained' : 'outlined'}
										className={`industry-tile ${
										selectedL1Item === l1Item ? 'selected-l1-tile' : ''
										}`}
										onClick={() => l1TileClickHandler(l1Item)}
									>
										{l1Item}
									</Button>
									)
								)
							}
						</div>

						<div className='industry-tiles-container'>L2 Process: &nbsp;&nbsp;&nbsp;
							{
								metaData?.length > 0 &&
								metaData[0]?.meta_data?.process_data?.classification_fields?.[selectedClassificationField]?.L2_Process[selectedL1Item]?.map(
									(l2Item) => (

									<Button
										key={l2Item}
										variant={selectedL2Item === l2Item ? 'contained' : 'outlined'}
										className={`industry-tile ${
										selectedL2Item === l2Item ? 'selected-l2-tile' : ''
										}`}
										onClick={() => l2TileClickHandler(l2Item)}
									>
										{l2Item}
									</Button>
									)
								)
							}
						</div>


						<div className='info-tabs'>
							<div className='selected-info-tab-details' style={{ height: 'auto', minHeight: 200 }}>
								<div className='selected-info-tab-title' style={{ marginBottom: 20 }}>Company</div>
								<div className="company-grid">
									{searchComapnyApiResponse?.data?.map((company, index) => (
										<div className="company-card" key={index} onClick={() => getCompanyDetails(company.id)}>
											<img
												src={company.company_logo_url}
												alt={company.name}
												className="company-logo"
											/>
											<div className="company-name">{company.name}</div>
										</div>
									))}
								</div>
							</div>
							
						</div>
						<br/><br/>
						{!isLoading && getComapnyDetailApiResponse && (
							<div className='info-tabs'>
								<div className='selected-info-tab-details' style={{ height: 'auto', minHeight: 200 }}>
									
										<>
											<div className='selected-info-tab-title' style={{ marginBottom: 20 }} >Company Details</div>
											<CompanyInfoPage companyDetails={getComapnyDetailApiResponse} scoringResult={companyScoringResult} domainDetails={domainCompaniesWithScoring} />
										</>
									
								</div>
							</div>
						)}

						<br/><br/>

						<div className='info-tabs'>
							<div className='info-tabs-container'>
								{infoTabs.map((infoTab) => (
									<Button
										key={infoTab}
										variant={`${selectedInfoTab === infoTab ? 'contained' : 'outlined'}`}
										className={`info-tab ${infoTab === selectedInfoTab ? 'selected-info-tab' : ''}`}
										onClick={() => infoTabClickHandler(infoTab)}
									>
										{infoTab}
									</Button>
								))}
							</div>
							
							<div className='info-tabs-container'>
								<button className="download-report-button" onClick={downloadReport}>
									<span className="text">Download Report</span>
									<span className="price">{credit}</span>
								</button>
							</div>
							<div className='selected-info-tab-details' style={{ height: 'auto', minHeight: 200 }}>
								<div className='selected-info-tab-title' style={{ marginBottom: 20 }}>{selectedInfoTab}</div>
								{(selectedInfoTab === 'Top GenAI Usecases') && (
									<div className='top-gen-ai-usecases-wrapper' style={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', overflow: 'auto' }}>
										{/* {singleCollectApiResponse?.company?.products?.map((product, index) => (
											<div className='product-item' key={index} style={{ width: 400, padding: 20, borderWidth: 1, borderStyle: 'solid', borderColor: 'lightgray', borderRadius: '16px', marginRight: 20 }}>
												<div className='product-title' style={{ fontWeight: 'bold' }}>{product.product_name}</div>
												<div className='divider' style={{ width: '100%', borderTopWidth: 1, borderTopStyle: 'solid', borderTopColor: 'lightgray', marginTop: 20, marginBottom: 20 }}></div>
												<div className='product-description' style={{}}>{product.product_description}</div>
											</div>
										))} */}
									</div>
								)}
								{(selectedInfoTab === 'ROI Calculator') && (
									<ROICalculatorPage/>
								)}
							</div>
						</div>
						<div className='scorecard-container'>
							<div className='scorecard-chart'>
								{/* <video width="750" height="500" loop autoPlay >
									<source src={videosrc} type="video/mp4" />
								</video> */}
								<PricingReliabilityGraph />
							</div>
							<div className='scorecard-chart-filters'>Scorecard Chart Filters</div>
						</div>
						<div className='product-comparison-table-container'>
							<ThemeProvider theme={createTheme({})}>
								<MaterialTable
									columns={[
										{
											title: 'Properties',
											field: 'properties',
											cellStyle: { cellWidth: '30%', color: '#808080', textTransform: 'none' }
										},
										{
											title: 'AI-1',
											field: 'ai1',
											cellStyle: { cellWidth: '20%', color: '#808080', textTransform: 'none' }
										},
										{
											title: 'AI-2',
											field: 'ai2',
											cellStyle: { cellWidth: '20%', color: '#808080', textTransform: 'none' }
										},
										{
											title: 'AI-3',
											field: 'ai3',
											cellStyle: { cellWidth: '20%', color: '#808080', textTransform: 'none' }
										}
									].filter(Boolean)}
									data={[
										{
											properties: 'Property 1',
											ai1: 'value 1.1',
											ai2: 'value 2.1',
											ai3: 'value 3.1'
										},
										{
											properties: 'Property 2',
											ai1: 'value 1.2',
											ai2: 'value 2.2',
											ai3: 'value 3.2'
										},
										{
											properties: 'Property 3',
											ai1: 'value 1.3',
											ai2: 'value 2.3',
											ai3: 'value 3.3'
										}
									]}
								/>
							</ThemeProvider>
						</div>
						<div className='scorecard-container'>
							<div className='scorecard-chart'>
								<Plot
									data={chartData}
									layout={chartLayout}
								/>
							</div>
								<div className='scorecard-chart' style={{ marginLeft: 20 }}>
									<Plot
										data={[
											{
												type: 'bar',
												x: ["Jun 24", "Dec 24", "Jun 25", "Dec 25"],
												y: [126, 289, 231, 562],
												marker: {
													color: ['lightgreen', '#FFD580', '#FF5252', 'lightblue']
												},
											},
										]}
										layout={{
											borderRadius: '15%',
											overflow: 'hidden',
											height: 240,
											width: 360,
											xaxis: {
												title: {
													text: 'Timeline',
													font: {
														size: 12,
														weight: 'bold'
													},
													standoff: 10
												},
												type: 'category',
												// tickangle: -45,
												automargin: true,
												tickfont: {
													weight: 'bold',
													size: 8
												}
											},
											yaxis: {
												title: {
													text: "FTE Count",
													font: {
														size: 12,
														weight: 'bold'
													},
													standoff: 10
												},
												type: 'linear',
												automargin: true,
												tickfont: {
													// weight: 'bold',
													size: 12
												},
												tickformat: ',.0f',
												separatethousands: true,
												hoverformat: ',.0f'
											},
											title: {
												text: "Employee Headcount",
												x: 0.5,
												xref: 'paper',
												font: {
													size: 18,
													weight: 'bold'
												}
											},
											margin: { t: 50, b: 20, l: 100, r: 10 },
											bargap: 0.5,
											scene: {
												camera: {
													eye: { x: 1.5, y: 1.5, z: 1.2 }
												}
											},
											transition: {
												duration: 1000,
												easing: 'cubic-in-out'
											}
										}}
									/>
									{/* Line Chart */}
									<Plot
										data={[
											{
												type: 'line',
												x: ["Jun 24", "Dec 24", "Jun 25", "Dec 25"],
												y: [254, 759, 1030, 1286],
												marker: {
													color: ['lightgreen', '#FFD580', '#FF5252', 'lightblue']
												},
											},
										]}
										layout={{
											borderRadius: '15%',
											overflow: 'hidden',
											height: 240,
											width: 360,
											xaxis: {
												title: {
													text: 'Timeline',
													font: {
														size: 12,
														weight: 'bold'
													},
													standoff: 10
												},
												type: 'category',
												// tickangle: -45,
												automargin: true,
												tickfont: {
													weight: 'bold',
													size: 8
												}
											},
											yaxis: {
												title: {
													text: "Million USD",
													font: {
														size: 12,
														weight: 'bold'
													},
													standoff: 10
												},
												type: 'linear',
												automargin: true,
												tickfont: {
													// weight: 'bold',
													size: 12
												},
												tickformat: ',.0f',
												separatethousands: true,
												hoverformat: ',.0f'
											},
											title: {
												text: "Revenue",
												x: 0.5,
												xref: 'paper',
												font: {
													size: 18,
													weight: 'bold'
												}
											},
											margin: { t: 20, b: 20, l: 20, r: 10 },
											bargap: 0.5,
											scene: {
												camera: {
													eye: { x: 1.5, y: 1.5, z: 1.2 }
												}
											},
											transition: {
												duration: 1000,
												easing: 'cubic-in-out'
											}
										}}
									/>
								</div>
						</div>
					</div>
				</div>
			)
		}
	</>
	)
};

export default SearchProductPage;